import React from 'react'
import Section from '../Section'
import Markdown from 'features/Markdown'
import CmsImg from 'features/Cms/Utils/CmsImg'
import s from './ProductScreenshot.scss'
import cn from 'classnames'

export default props => (
  <Section
    color={props.color}
    fullHeight={props.fullHeight}
    paddingTop={props.paddingTop}
    paddingBottom={props.paddingBottom}
    sectionWidth={props.sectionWidth}
    style={{ textAlign: 'center', overflow: 'hidden' }}
    pattern={props.pattern}
  >
    <Markdown text={props.text} color={props.color} />
    <div className={s.frame}>
      <div className={s.frameChrome}>
        <div className={cn(s.dot, s.red)} />
        <div className={cn(s.dot, s.orange)} />
        <div className={cn(s.dot, s.green)} />
      </div>
      <div className={s.inner}>
        <CmsImg src={props.screenshot} />
      </div>
    </div>
  </Section>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/ProductScreenshot/ProductScreenshot.jsx